/**
 * Oynatıcıdaki "sıradaki" düğmesi.
 *
 * ## Neden ayrı bileşen?
 *
 * `PlayerBar` zaten altyazı menüsü, ses, hız ve tam ekran gibi birçok
 * sorumluluğu taşıyor. "Sıradaki" kuralı (bağlama göre parça mı bölüm mü,
 * sıradaki yoksa ne yazılacak) **oynatıcı çubuğunun işi değil**; ayrı bir
 * bileşende tutulur:
 *
 *   - `PlayerBar` yalnız düğmeyi yerleştirir,
 *   - erişilebilirlik metni ve etiket bu dosyada üretilir,
 *   - düğmenin görünümü `player.css` içinde tek yerde tanımlıdır.
 */

import type { ReactNode } from 'react';
import { SkipNextIcon } from '../Icon.tsx';

export interface PlayerNextButtonProps {
  /** Sıradaki içerik var mı? Yoksa düğme pasif görünür. */
  hasNext: boolean;
  /** Sıradaki içeriğin başlığı (ipucu ve erişilebilirlik metni için). */
  nextTitle?: string | null;
  /** Sıradakine geç. */
  onNext: () => void;
}

export function PlayerNextButton({ hasNext, nextTitle, onNext }: PlayerNextButtonProps): ReactNode {
  const label =
    hasNext && nextTitle ? `Sıradaki: ${nextTitle}` : hasNext ? 'Sıradaki' : 'Sıradaki yok';

  return (
    <button
      type="button"
      className="player__button player__button--next"
      onClick={onNext}
      disabled={!hasNext}
      aria-label={label}
      title={hasNext ? `${label} (N)` : label}
    >
      <SkipNextIcon size={18} />
    </button>
  );
}
